export default "__VITE_ASSET__Bc88zYEF__"